define('helpers/page', [], function () {
    function Model() {
        var self = this;

        self.adjustPageMessages = function () {
            var $header = $("#header"),
                $container = $(".mainContainer"),
                $message = $("#page-message");

            var $push = $("<div><div>");

            var messageHeight = $message.outerHeight();

            if (messageHeight > 0) {
                $push.css({ 'height': messageHeight });
                $push.prependTo($header);

                $container.addClass('with-message');

                $container.css({
                    'margin-top': -messageHeight + 'px'
                });
            }
        }
    }

    return new Model();
})